import cx from 'classnames';
import {useCallback} from 'react';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {useTracking} from '~library/context/tracking/tracking-context';
import {ArrowIcon} from '~library/svg/ArrowIcon';
import {CloseLineIcon} from '~library/svg/CloseLineIcon';

import * as styles from './DrawerHeader.module.scss';

type DrawerHeaderProps = {
  onClose: () => void;
  showBackButton?: boolean;
  onBackClick?: () => void;
  title?: string;
};

export const DrawerHeader = ({
  onClose,
  showBackButton = false,
  onBackClick,
  title,
}: DrawerHeaderProps) => {
  const {track} = useTracking();

  const handleClose = useCallback(() => {
    track({
      dataQaId: 'mobile-category-drawer-close',
    });
    onClose();
  }, [onClose, track]);

  const handleBack = useCallback(() => {
    track({
      dataQaId: 'mobile-category-drawer-back',
    });
    onBackClick?.();
  }, [onBackClick, track]);

  return (
    <div
      className={cx(styles.container, {
        [styles.containerReverse]: !showBackButton && !title,
      })}
    >
      {showBackButton && onBackClick && (
        <Button
          onClick={handleBack}
          data-qa-id="mobile-category-drawer-back"
          variant="unstyled-button"
        >
          <ArrowIcon direction="left" ratio={0.75} />
        </Button>
      )}

      {title && (
        <Typography variant="paragraph2" semibold className={styles.title}>
          {title}
        </Typography>
      )}

      <Button
        onClick={handleClose}
        className={styles.closeBtn}
        data-qa-id="mobile-category-drawer-close"
        variant="unstyled-button"
      >
        <CloseLineIcon ratio={0.75} />
      </Button>
    </div>
  );
};
